import * as React from 'react';

export const MobileMenu = () => {
  return <div></div>;
};
